import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import commonEn from 'componentlibrary/dist/translations/en.json';
import commonFr from 'componentlibrary/dist/translations/fr.json';
import commonEs from 'componentlibrary/dist/translations/es.json';
import commonEsMX from 'componentlibrary/dist/translations/es-MX.json';
import commonEsCL from 'componentlibrary/dist/translations/es-CL.json';
import commonEsCO from 'componentlibrary/dist/translations/es-CO.json';
import commonEsBO from 'componentlibrary/dist/translations/es-BO.json';
import commonEsAR from 'componentlibrary/dist/translations/es-AR.json';
import commonEsPE from 'componentlibrary/dist/translations/es-PE.json';
import commonMn from 'componentlibrary/dist/translations/mn.json';
import commonPt from 'componentlibrary/dist/translations/pt.json';
import commonRu from 'componentlibrary/dist/translations/ru.json';
import commonIs from 'componentlibrary/dist/translations/is.json';
import commonNb from 'componentlibrary/dist/translations/nb.json';
import commonZh from 'componentlibrary/dist/translations/zh.json';
import commonId from 'componentlibrary/dist/translations/id.json';
import commonTpi from 'componentlibrary/dist/translations/tpi.json';
import commonNl from 'componentlibrary/dist/translations/nl.json';
import commonDe from 'componentlibrary/dist/translations/de.json';
import commonIt from 'componentlibrary/dist/translations/it.json';
import commonSr from 'componentlibrary/dist/translations/sr.json';
import commonFi from 'componentlibrary/dist/translations/fi.json';
import commonJa from 'componentlibrary/dist/translations/ja.json';
import commonPl from 'componentlibrary/dist/translations/pl.json';
import commonHi from 'componentlibrary/dist/translations/hi.json';
import commonUk from 'componentlibrary/dist/translations/uk.json';
import commonEl from 'componentlibrary/dist/translations/el.json';
import commonTr from 'componentlibrary/dist/translations/tr.json';
import commonTl from 'componentlibrary/dist/translations/tl.json';
import commonMs from 'componentlibrary/dist/translations/ms.json';
import commonSw from 'componentlibrary/dist/translations/sw.json';
import appEn from './en.json'; // english
import appFr from './fr.json'; // french
import appEs from './es.json'; // spanish
import appEsMX from './es-MX.json'; // spanish (mexico)
import appEsCL from './es-CL.json'; // spanish (chile)
import appEsCO from './es-CO.json'; // spanish (colombia)
import appEsBO from './es-BO.json'; // spanish (bolivia)
import appEsAR from './es-AR.json'; // spanish (argentina)
import appEsPE from './es-PE.json'; // spanish (peru)
import appMn from './mn.json'; // mongolian
import appPt from './pt.json'; // portuguese (brazil)
import appRu from './ru.json'; // russian
import appIs from './is.json'; // icelandic
import appNb from './nb.json'; // norwegian (bokmål)
import appZh from './zh.json'; // chinese (simplified)
import appId from './id.json'; // indonesian
import appTpi from './tpi.json'; // tok Pisin
import appNl from './nl.json'; // dutch
import appDe from './de.json'; // german
import appIt from './it.json'; // italian
import appSr from './sr.json'; // serbian
import appFi from './fi.json'; // finnish
import appJa from './ja.json'; // japanese
import appPl from './pl.json'; // polish
import appHi from './hi.json'; // hindi
import appUk from './uk.json'; // ukrainian
import appEl from './el.json'; // greek
import appTr from './tr.json'; // turkish
import appTl from './tl.json'; // tagalog
import appMs from './ms.json'; // Bahasa Malaysian “Malay”
import appSw from './sw.json'; // swahili

const en = { ...commonEn, ...appEn };
const fr = { ...commonFr, ...appFr };
const es = { ...commonEs, ...appEs };
const esMX = { ...commonEsMX, ...appEsMX };
const esCL = { ...commonEsCL, ...appEsCL };
const esCO = { ...commonEsCO, ...appEsCO };
const esBO = { ...commonEsBO, ...appEsBO };
const esAR = { ...commonEsAR, ...appEsAR };
const esPE = { ...commonEsPE, ...appEsPE };
const mn = { ...commonMn, ...appMn };
const pt = { ...commonPt, ...appPt };
const ru = { ...commonRu, ...appRu };
const is = { ...commonIs, ...appIs };
const nb = { ...commonNb, ...appNb };
const zh = { ...commonZh, ...appZh };
const id = { ...commonId, ...appId };
const tpi = { ...commonTpi, ...appTpi };
const nl = { ...commonNl, ...appNl };
const de = { ...commonDe, ...appDe };
const it = { ...commonIt, ...appIt };
const sr = { ...commonSr, ...appSr };
const fi = { ...commonFi, ...appFi };
const ja = { ...commonJa, ...appJa };
const pl = { ...commonPl, ...appPl };
const hi = { ...commonHi, ...appHi };
const uk = { ...commonUk, ...appUk };
const el = { ...commonEl, ...appEl };
const tr = { ...commonTr, ...appTr };
const tl = { ...commonTl, ...appTl };
const ms = { ...commonMs, ...appMs };
const sw = { ...commonSw, ...appSw };

export const SELECT_LOCALE = 'i18nextLng';

function initialiseI18nModule() {
  i18n
    .use(LanguageDetector)
    .init({
      fallbackLng: {
        'pt-PT': ['pt'],
        'pt-BR': ['pt'],
        'zh-Hans': ['zh'],
        'es-ES': ['es'],
        'es-MX': ['es'],
        'es-CL': ['es'],
        'es-CO': ['es'],
        'es-BO': ['es'],
        'es-AR': ['es'],
        'es-PE': ['es'],
        ar: ['en'],
        default: ['en'],
      },
      debug: false,
      interpolation: {
        escapeValue: false, // not needed for react!!
      },
      detection: {
        // order and from where user language should be detected
        order: ['localStorage', 'navigator', 'querystring', 'cookie', 'htmlTag', 'path', 'subdomain'],
        lookupLocalStorage: SELECT_LOCALE,
        caches: ['localStorage'],
      },
      // lng: 'es', // If you want to enforce a default language
      // react i18next special options (optional)
      react: {
        wait: false,
        useSuspense: true, // If you're using React Suspense
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default',
      },
      resources: {
        en,
        fr,
        es,
        'es-MX': esMX,
        'es-CL': esCL,
        'es-CO': esCO,
        'es-BO': esBO,
        'es-AR': esAR,
        'es-PE': esPE,
        mn,
        pt,
        ru,
        is,
        nb,
        zh,
        id,
        tpi,
        nl,
        de,
        it,
        sr,
        fi,
        ja,
        pl,
        hi,
        uk,
        el,
        tr,
        tl,
        ms,
        sw,
      },
    })
    .then(() => {
      // Register the language change event listener here
      i18n.on('languageChanged', (lng) => {
        document.documentElement.lang = lng;
      });
    })
    .catch((err) => {
      console.error('i18next initialization error:', err);
    });
}

export function clearLocaleSelection() {
  initialiseI18nModule();
}

initialiseI18nModule();

export default i18n;
